import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "../../axios-backend";
import Line from "../main/Line";
import Button from "../main/Button";
import BackButton from "../main/BackButton";

// terminologies
// gender (1|2) 1-> male | 2-> female
// type (1|2|3|4|5) 1-> product details + authenticity | 2-> only authenticity | 3-> product dimension | 4-> male | 5-> female
const AdPicture = (props) => {
  const { id } = useParams();
  const [imgs, setImgs] = useState([]);
  const [type, setType] = useState(0);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    // Fetch and display existing dimension images for this product
    axios
      .get("/get-imgs-by-pid", {
        params: { id, type: 3 },
      })
      .then((data) => {
        if (data.data.status === 200) {
          setImgs(data.data.imgs);
        }
      });
  }, [id]);

  const handleUpload = () => {
    if (type) {
      let formData = new FormData();
      imgs.forEach((item) => {
        formData.append("imgs", item);
      });
      formData.append('id', id);
      formData.append('type', type);
      formData.append('index', index);
      axios({
        method: 'post',
        url: '/uploadimgs',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(data => {
        if (data.data.status === 200) {
          window.history.back();
        } else {
          alert(data.data.msg)
        }
      }).catch(r => {
        console.log(r);
      })
    } else {
      alert('select a type');
    }
  }

  const handleChangeImg = (e) => {
    const files = e.target.files;
    if (files.length > 0 && files.length <= 10) {
      const length = files.length;
      for (let i = 0; i < 10; i++) {
        const preview = document.querySelector(`#img-files${i}`);
        preview.src = '';
        preview.style.display = 'none';
      }
      const arr = [];
      for (let i = 0; i < length; i++) {
        const file = files[i];
        arr.push(file);
        const preview = document.querySelector(`#img-files${i}`);
        const reader = new FileReader();
        reader.onloadend = function () {
          preview.src = reader.result;
          preview.style.display = 'block';
        }
        reader.readAsDataURL(file);
      }
      setImgs(arr);
    } else {
      alert('please select no more than 10 pictures');
      return;
    }
  }
  return (
    <div style={{ height: "100%" }}>
      <BackButton />
      <Line type="bottom-line">
        Page for adding picture(s) to product.  Please note that maximum 10 files per uploading
      </Line>
      <Line type="bottom-line">
        picture type:
        <select onChange={e => { setType(e.target.value) }} value={type}>
          <option value="0" disabled>Select a type</option>
          <option value="2">authenticity image only</option>
          <option value="4">product details - men</option>
          <option value="5">product details - women</option>
        </select>
        <span style={{ marginLeft: "1rem", color: "red" }}>
          check the type before uploading images
        </span>
      </Line>
      <Line type="bottom-line">
        picture index: <input
          type="number"
          id="index"
          name="index"
          value={index}
          onChange={(e) => {
            setIndex(e.target.value);
          }}
        />
      </Line>
      <Line type="bottom-line">
        <input type="file" accept="image/*" name="file" multiple onChange={handleChangeImg} />
      </Line>
      {/* Display all the dimension images for this product */}
      <Line type="bottom-line">
        <div className="imgs-container">
          <div className="img-of-product">All the images: </div>
          {imgs.length > 0 ? imgs.map((item, idx) => (
            <div className="img-of-product" key={idx}>
              {item.url ? (
                <img
                  src={item.url.startsWith("s3")
                    ? `https://wonwonleywon-images.s3.amazonaws.com/product_images/${item.url}`
                    : `${process.env.REACT_APP_Url}${item.url}`}
                  width="150px"
                  alt="img-product"
                  height="150px"
                />
              ) : (
                <span style={{ color: 'red' }}>Invalid image data</span>
              )}
            </div>
          )) : <span>No images found.</span>}
        </div>
      </Line>
      <div style={{ height: "38.5%", display: "flex", flexWrap: "wrap", padding: "2rem" }}>
        <img src="" width="150px" alt='img-product' height="150px" style={{ display: 'none' }} id="img-files0" />
        <img src="" width="150px" alt='img-product' height="150px" style={{ display: 'none' }} id="img-files1" />
        <img src="" width="150px" alt='img-product' height="150px" style={{ display: 'none' }} id="img-files2" />
        <img src="" width="150px" alt='img-product' height="150px" style={{ display: 'none' }} id="img-files3" />
        <img src="" width="150px" alt='img-product' height="150px" style={{ display: 'none' }} id="img-files4" />
        <img src="" width="150px" alt='img-product' height="150px" style={{ display: 'none' }} id="img-files5" />
        <img src="" width="150px" alt='img-product' height="150px" style={{ display: 'none' }} id="img-files6" />
        <img src="" width="150px" alt='img-product' height="150px" style={{ display: 'none' }} id="img-files7" />
        <img src="" width="150px" alt='img-product' height="150px" style={{ display: 'none' }} id="img-files8" />
        <img src="" width="150px" alt='img-product' height="150px" style={{ display: 'none' }} id="img-files9" />
      </div>
      <Line type="top-line">
        <Button onClick={handleUpload}>Upload</Button>
      </Line>
      <Line type="top-line"></Line>
      <Line type="top-line"></Line>
      <Line type="top-line"></Line>
    </div>
  )
}

export default AdPicture;
